export const environment = {
    production: false,
    version: '114',
    buildDate: '2026-04-25',
    firebase: {
        apiKey: "AIzaSyBGQsQkigj_r9FTXpuT3qalR2TWHOsQ_a4",
        authDomain: "mevolve-connect-dev.firebaseapp.com",
        projectId: "mevolve-connect-dev",
        storageBucket: "mevolve-connect-dev.firebasestorage.app",
        messagingSenderId: "388052013510",
        appId: "1:388052013510:web:6303d7a2fbf49b5f1aa2c7",
        measurementId: "G-V7V3Q3VY3K"
    },
    fbApiUrl: 'https://us-central1-mevolve-connect-dev.cloudfunctions.net',
    fbEmuApiUrl: 'http://127.0.0.1:5000/mevolve-connect-dev/us-central1',
    webDomain: 'https://preview.mevolve-connect.pages.dev',
    assetsBaseUrl: 'https://pub-7d557a47abf94937bc340ad244fede22.r2.dev',
    // Set to true to use local Firebase Functions emulator (port 5001)
    useEmulator: false
};